import tpl from './templates';

export const MOTOTSIKL = {
  make: tpl.make,
  make_model: tpl.make_model,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/index.js